<template>
  <div>
    <v-layout wrap justify-start>
      <v-flex xs12 text-left>
        <span style="font-family: poppinsbold; font-size: 25px; color: #000000">
          {{ name }}
        </span>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-start>
      <v-flex xs12 sm12 md12 1g12 xl12 pa-2>
        <v-slide-group :show-arrows="true">
          <v-slide-item v-for="(item, i) in products" :key="i">
            <v-layout wrap justify-start>
              <v-flex xs12 px-4>
                <v-card
                  tile
                  flat
                  :max-width="widthOfCard"
                  @click="
                    $router.push(
                      '/Products/' + item.productname + '/' + item._id
                    )
                  "
                >
                  <ProductsSliderItem v-bind:product="item" />
                </v-card>
              </v-flex>
            </v-layout>
          </v-slide-item>
        </v-slide-group>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import ProductsSliderItem from "./productsSliderItem";
export default {
  components: {
    ProductsSliderItem,
  },
  props: ["name", "products"],
  data() {
    return {
      widthOfCard: "150px",
    };
  },
};
</script>